import { Injectable, Injector } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import * as _ from "lodash";
import { Observable } from "rxjs";
import { isNullOrUndefined } from 'src/app/services/utils';
import { environment } from "../../environments/environment";
import {
  COMMON_CONSTANTS,
  MANAGE_LINE_CONST,
  TRANSACTION_HISTORY_CONSTANTS,
} from "../common/core/common.constants";
import { ContentService } from "./content.service";
import { EntitlementService } from "./entitlement.service";
import { EnvironmentDetailsService } from "./environment-details.service";
import { HelperUtilityService } from "./helper-utility.service";
import { HttpCacheService } from "./http-cache.service";
import { LoaderService } from "./loader.service";
import { OktaAuthorizationService } from "./okta-auth-service";
import { AzureAuthorizationService } from "./azure-auth-service";
import { SetupRouteService } from "./setup-route.service";
import { UtilsService } from "./utils.service";
import { DecodeParamsService } from "./decode-params.service";
import { ManageLineService } from "./manage-line.service";
import { PnpClientService } from "src/pnpframework/public-api";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { AlertConfirmPopupComponent } from "../common/alert-confirm-popup";
import { SplunkUtilityService } from './splunk-utility.service';
import { AuthHttpService } from "./http-wrapper.service";



@Injectable()
export class AccountManagementResolver implements CanActivate {
  isResolved: boolean;
  authoringContentData: any;
  dealerCode: any = COMMON_CONSTANTS.DEALER_CODE_VAL;
  ssoMessage = { error: "", show: true, errorType: "generic" };
  isRedirect = false;
  transactionID: number;
  changeServicesFlag = false;
  lineDetailsFlag = false;
  enableAhubFlow = false;
  enableAuthorization = false;
  euiCode: any;
  redirectionUrl = "";
  OrgID: string;
  userId: string;
  idpType:string;
  euiData: {
    lastName: any;
    firstName: any;
    orgId: any;
    logonId: any;
    autoGeneratedFlag: any;
    userId: any;
    roles: any;
  };
  snagPopupRef: any;
  _oktaAuthService: OktaAuthorizationService;
  _azureAuthService: AzureAuthorizationService;
  _cacheSvc: HttpCacheService;
  _envSvc: EnvironmentDetailsService;
  contentService: ContentService;
  _router: Router;
  _loaderSvc: LoaderService;
  setUpRouteSvc: SetupRouteService;
  entitlementSvc: EntitlementService;
  utilsSvc: UtilsService;
  _helperUtilSvc: HelperUtilityService;
  decodeParamsSvc: DecodeParamsService;
  manageLineSvc: ManageLineService;
  pnpClientService: PnpClientService;
  modalService: NgbModal;
  splunkSvc: SplunkUtilityService;
  httpClient: AuthHttpService;

  constructor(
    private injector : Injector
  ) {this._oktaAuthService = this.injector.get<OktaAuthorizationService>(OktaAuthorizationService);
    this._azureAuthService = this.injector.get<AzureAuthorizationService>(AzureAuthorizationService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this._envSvc = this.injector.get<EnvironmentDetailsService>(EnvironmentDetailsService);
    this.contentService = this.injector.get<ContentService>(ContentService);
    this._router = this.injector.get<Router>(Router);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.setUpRouteSvc = this.injector.get<SetupRouteService>(SetupRouteService);
    this.entitlementSvc = this.injector.get<EntitlementService>(EntitlementService);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.decodeParamsSvc = this.injector.get<DecodeParamsService>(DecodeParamsService);
    this.manageLineSvc = this.injector.get<ManageLineService>(ManageLineService);
    this.pnpClientService = this.injector.get<PnpClientService>(PnpClientService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.splunkSvc = this.injector.get<SplunkUtilityService>(SplunkUtilityService);
    this.httpClient = this.injector.get<AuthHttpService>(AuthHttpService);
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.enableAhubFlow = environment.ENABLE_RAHUB_FLOW;
    this.enableAuthorization = environment.ENABLE_AUTHORIZATION;

    let queryParamStoredInSession = this._cacheSvc.getFromSessionStorage(
      COMMON_CONSTANTS.QUERY_PARAM_UID
    );
    this.idpType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE);
    if(this.pnpClientService.isRunningInGlobalNav() && next.routeConfig.path.includes('home')){
      this._cacheSvc.deleteFromSessionStoarage(COMMON_CONSTANTS.EUI_TOKEN_DATA);
    }
    let queryParamFromUrl =
      !_.isNull(next) &&
      !_.isNull(next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY))
        ? next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY)
        : queryParamStoredInSession;
    /** Updating session while switching orgs & user in the same tab */
    if (!_.isEqual(queryParamFromUrl, queryParamStoredInSession)) {
      const queryParam = this.decodeParamsSvc.decodeBase64(
        next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY)
          ? next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY)
          : ""
      );

      this.OrgID = queryParam[COMMON_CONSTANTS.ORG_ID_KEY]
        ? queryParam[COMMON_CONSTANTS.ORG_ID_KEY]
        : this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY);
      this.userId = queryParam[COMMON_CONSTANTS.USER_ID]
        ? queryParam[COMMON_CONSTANTS.USER_ID]
        : this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.USER_ID);

      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.ORG_ID_KEY,
        this.OrgID
      );
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.USER_ID,
        this.userId
      );
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.QUERY_PARAM_UID,
        queryParamFromUrl
      );
      this._cacheSvc.deleteFromSessionStoarage(COMMON_CONSTANTS.EUI_TOKEN_DATA);
    }

    if (
      _.isNull(
        this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)
      ) &&
      this.enableAhubFlow
    ) {
      // IAM Redirection for AM App to any page
      if (
        !_.isNull(next) &&
        !_.isNull(next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY))
      ) {
        this.setUpRouteSvc.saveParamsInSession(next);
        this.setRedirectURL(next);
        this._cacheSvc.putInSessionStoarage(
          "queryParamUID",
          next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY)
        );
      } else if(this.pnpClientService.isRunningInGlobalNav()) {
        this.setRedirectURL(next);
      }

      if (next && environment.SSO_ON) {
        if (
          this._cacheSvc.getFromSessionStorage("IDPType") ===
          COMMON_CONSTANTS.OKTA_KEY ) {
          if (next?.queryParams?.code) {
            sessionStorage.setItem(
              COMMON_CONSTANTS.OKTA_AUTH_CODE_KEY,
              next.queryParams.code
            );

            if (!sessionStorage.getItem(COMMON_CONSTANTS.TRANSACTIONID)) {
              const now = new Date();
              this.transactionID = now.valueOf();
              this._cacheSvc.putInSessionStoarage(
                COMMON_CONSTANTS.TRANSACTIONID,
                this.transactionID
              );
            }

            this.tokenResolvedAhubOkta(next);
          } else if (next?.queryParams?.error) {
            this._router.navigate([COMMON_CONSTANTS.RESTRICT_PAGE_URL]);
          } else {
            if(this.pnpClientService.isRunningInGlobalNav()){
              return this.tokenResolvedAhubOkta(next)
            }else{
              return this._oktaAuthService.loginWithOkta();
            }
          }
        } else if (this._cacheSvc.getFromSessionStorage("IDPType") ===
        COMMON_CONSTANTS.AZURE_KEY){
            return this.tokenResolvedAhubAzure(next);
        } else {
          if (
            !this.pnpClientService.isRunningInGlobalNav() &&
            next.queryParamMap.get(COMMON_CONSTANTS.UID_KEY) &&
            !this._cacheSvc.getFromSessionStorage(
              COMMON_CONSTANTS.ACCESS_TOKEN_KEY
            )
          ) {

            this.setUpRouteSvc.euiLoginRedirect();


          } else {
            return this.tokenResolvedAhub(next.queryParams);
          }
        }
      } else {
        return this.tokenResolvedAhub(next);
      }
    } else if (
      _.isNull(sessionStorage.getItem(COMMON_CONSTANTS.OKTA_USER_PROFILE)) &&
      !this.enableAhubFlow
    ) {
      if (next && next.queryParams.code) {
        sessionStorage.setItem(
          COMMON_CONSTANTS.OKTA_AUTH_CODE_KEY,
          next.queryParams.code
        );

        if (!sessionStorage.getItem(COMMON_CONSTANTS.TRANSACTIONID)) {
          const now = new Date();
          this.transactionID = now.valueOf();
          this._cacheSvc.putInSessionStoarage(
            COMMON_CONSTANTS.TRANSACTIONID,
            this.transactionID
          );
        }

        this.tokenResolvedOkta();
      } else if (next && next.queryParams.error) {
        this._router.navigate([COMMON_CONSTANTS.RESTRICT_PAGE_URL]);
      } else {
        return (
          this.pnpClientService.isRunningInGlobalNav()
            ? this.tokenResolvedOkta()
            : this._oktaAuthService.loginWithOkta(),
          false
        );
      }
    } else {
      if (
        next.routeConfig.path ===
          TRANSACTION_HISTORY_CONSTANTS.REDIRECT_TO_LOGIN_PAGE ||
        next.routeConfig.path === COMMON_CONSTANTS.CALLBACK
      ) {
        this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_HOME]);
      } else {
        return true;
      }
    }
  }

  setRedirectURL(next) {
    this.redirectionUrl = next.parent.routeConfig.path;
    next.url.forEach((element) => {
      this.redirectionUrl = this.redirectionUrl + "/" + element.path;
    });
    this._cacheSvc.putInSessionStoarage(
      "reDirectionUrl",
      this.redirectionUrl
    );
  }

  tokenResolvedOkta() {
    this._oktaAuthService.getOktaaAccessToken().then((response) => {
      sessionStorage.setItem(
        COMMON_CONSTANTS.OKTA_ACCESS_TOKEN_KEY,
        response["access_token"]
      );
      sessionStorage.setItem(
        COMMON_CONSTANTS.OKTA_ID_TOKEN,
        response["id_token"]
      );
      sessionStorage.setItem(COMMON_CONSTANTS.ID_TOKEN, response["id_token"]);

      this._oktaAuthService.getOktaUserProfile().then((userProfile) => {
        if (environment.ENABLE_ENTITLEMENT) {
          this.tokenResolved(userProfile);
        } else if (environment.ENABLE_RAHUB_FLOW) {
          this._cacheSvc.putInSessionStoarage(
            COMMON_CONSTANTS.IS_HANDSHAKE_COMPLETE,
            COMMON_CONSTANTS.TRUE_TXT
          );
          this._cacheSvc.putInSessionStoarage(
            COMMON_CONSTANTS.EUI_TOKEN_DATA,
            JSON.stringify(userProfile)
          );
        } else {
          this._router.navigate([COMMON_CONSTANTS.RESTRICT_PAGE_URL]);
          return false;
        }
      });
    });
  }

  tokenResolved(userProfile) {
    sessionStorage.setItem(
      COMMON_CONSTANTS.OKTA_USER_PROFILE,
      JSON.stringify(userProfile)
    );
    this._cacheSvc.putInSessionStoarage(
      COMMON_CONSTANTS.EUI_TOKEN_DATA,
      JSON.stringify(userProfile)
    );
    this._cacheSvc.putInSessionStoarage(
      COMMON_CONSTANTS.IS_HANDSHAKE_COMPLETE,
      COMMON_CONSTANTS.TRUE_TXT
    );
    // return this._apigeeSvc.getTokens().then((token) => {
    if (!this.isRedirect) {
      // tslint:disable-next-line:max-line-length
      return this.contentService
        .GetContentData(
          this._envSvc.CURR_CONTENT_URLS.CONTENT_ACCOUNT_MANAGEMENT
        )
        .then((data) => {
          this._loaderSvc.stop();
          this.authoringContentData = data.par.account_management_authoring;
          this._cacheSvc.putInSessionStoarage(
            COMMON_CONSTANTS.CONTENT,
            JSON.stringify(this.authoringContentData)
          );
          ContentService.SetCache(
            COMMON_CONSTANTS.CONTENT,
            this.authoringContentData
          );
          this._cacheSvc.putInSessionStoarage(
            MANAGE_LINE_CONST.AUTHENTICATION_INFO,
            // tslint:disable-next-line: max-line-length
            JSON.stringify({
              logonID: userProfile.logonId,
              logonEmail: userProfile.logonId,
              dealerCode: this.dealerCode,
            })
          );
          this._cacheSvc.putInSessionStoarage(
            COMMON_CONSTANTS.ORG_ID_KEY,
            this._helperUtilSvc.getOrgID()
          );
          this._oktaAuthService.notifyUserInfo.next(userProfile);
          this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_HOME]);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  tokenResolvedAhub(next) {
    this.euiCode = _.get(next, COMMON_CONSTANTS.EUI_CODE, "");
    return this.entitlementSvc.getIamAccessToken(this.euiCode).then((data) => {
      const idTokenArr = data?.id_tokens ? data.id_tokens : [];
      let token: string = "";
      const microAppId = environment?.PNP_CONFIG?.microAppId || 'tfb_acctmgmt';
      if( idTokenArr && `${microAppId}_idToken` in idTokenArr){
        token = this.enableAuthorization ? idTokenArr[`${microAppId}_idToken`] : '';
      }else{
        idTokenArr.forEach((tokenObj: any) => {
          if (
            this.enableAuthorization &&
            !_.isEmpty(tokenObj) &&
            !_.isEmpty(tokenObj["id_token.none"])
          ) {
            token = tokenObj["id_token.none"];
          }
        });
      }
      sessionStorage.setItem(COMMON_CONSTANTS.ID_TOKEN, token);
      const userProfile = data?.userInfo;
      let chubId;
      let pnpOrgId;
      sessionStorage.setItem(
        "IAM_USER_PROFILE",
        JSON.stringify(userProfile?.iamProfile)
      );

      let pnpPersistedContext = this._helperUtilSvc.getUserIdfromPnpContext();
      let contextDetails;
      if(!isNullOrUndefined(pnpPersistedContext)){
        contextDetails = JSON.parse(pnpPersistedContext);
      }
      chubId = !isNullOrUndefined(contextDetails.userId) ? contextDetails.userId : '';
      pnpOrgId = !isNullOrUndefined(contextDetails.orgId) ? contextDetails.orgId : '';
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.IAM_USER_ID,chubId);
      this.euiData = {
        lastName: userProfile.iamProfile.lastname,
        firstName: userProfile.iamProfile.firstname,
        orgId: pnpOrgId,
        logonId: userProfile.iamProfile.email,
        autoGeneratedFlag: userProfile.iamProfile.autoGeneratedFlag,
        userId: chubId,
        roles: userProfile.roles,
      };
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.EUI_TOKEN_DATA,
        JSON.stringify(this.euiData)
      );
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.IS_HANDSHAKE_COMPLETE,
        COMMON_CONSTANTS.TRUE_TXT
      );
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.ORG_ID_KEY,
        pnpOrgId
      );

      // return this._apigeeSvc.getTokens().then((token) => {
      if (!this.isRedirect) {
        // tslint:disable-next-line:max-line-length
        return this.contentService
          .GetContentData(
            this._envSvc.CURR_CONTENT_URLS.CONTENT_ACCOUNT_MANAGEMENT
          )
          .then((response) => {
            this._loaderSvc.stop();
            this.authoringContentData = response?.par?.account_management_authoring;
            this._cacheSvc.putInSessionStoarage(
              COMMON_CONSTANTS.CONTENT,
              JSON.stringify(this.authoringContentData)
            );
            ContentService.SetCache(
              COMMON_CONSTANTS.CONTENT,
              this.authoringContentData
            );
            this._cacheSvc.putInSessionStoarage(
              MANAGE_LINE_CONST.AUTHENTICATION_INFO,
              // tslint:disable-next-line: max-line-length
              JSON.stringify({
                logonID: this.euiData.logonId,
                logonEmail: this.euiData.logonId,
                dealerCode: this.dealerCode,
              })
            );
            this._cacheSvc.putInSessionStoarage(
              COMMON_CONSTANTS.ORG_ID_KEY,
              this._helperUtilSvc.getOrgID()
            );

            if (
              this._cacheSvc.getFromSessionStorage("IDPType") ===
              COMMON_CONSTANTS.IAM_KEY
            ) {
              if (
                !isNullOrUndefined(this.euiData) &&
                !isNullOrUndefined(this.euiData.orgId) &&
                !isNullOrUndefined(this.euiData.userId)
              ) {
                if (environment.ENABLE_CW_NON_IOT) {
                  const requestBody = {
                    userId: this._helperUtilSvc.getUserId(),
                    showActivities: true,
                  };

                  return this.entitlementSvc
                    .getUserActivities(
                      chubId,
                      this._helperUtilSvc.getOrgID(),
                      requestBody
                    )
                    .then((userActivityResp) => {
                      const responseObj = {
                        responseList: userActivityResp.activities,
                        status: this.authoringContentData.resolverContent ?
                                this.authoringContentData.resolverContent.success : "SUCCESS",
                        message: this.authoringContentData.resolverContent ?
                                this.authoringContentData.resolverContent.successMessage : "Successfully fetched data",
                      };

                      if (
                        !isNullOrUndefined(userActivityResp.role && userActivityResp.role.roleName) &&
                        userActivityResp.role.roleName == COMMON_CONSTANTS.END_USER
                      ) {
                        this._cacheSvc.putInSessionStoarage(
                          COMMON_CONSTANTS.ENABLE_ENDUSER,
                          true
                        );
                      } else {
                        this._cacheSvc.deleteFromSessionStoarage(
                          COMMON_CONSTANTS.ENABLE_ENDUSER
                        );
                      }

                      if (
                        !isNullOrUndefined(
                          userActivityResp.userPortalDetails && userActivityResp.userPortalDetails[0]
                        )
                      ) {
                        if (
                          userActivityResp.userPortalDetails[0].isBlockedFlag ===
                          MANAGE_LINE_CONST.Y_CTA
                        ) {
                          this.utilsSvc.userMgmtRestrictedPage();
                        } else if (
                          userActivityResp.goToRoleChooser == COMMON_CONSTANTS.TRUE_TXT
                        ) {
                          this.utilsSvc.redirectToRoleChooser();
                        }
                        this._cacheSvc.putInSessionStoarage(
                          COMMON_CONSTANTS.SHOW_ROLE_CHOOSER,
                          userActivityResp.showRoleChooser
                        );
                      }

                      if (!isNullOrUndefined(userActivityResp.role && userActivityResp.role.roleName)) {
                        userActivityResp.role.roleName =
                        userActivityResp.role.productType ===
                          COMMON_CONSTANTS.DIGITS.THREE.toString()
                            ? COMMON_CONSTANTS.IOT
                            : userActivityResp.role.roleName;
                        this._cacheSvc.putInSessionStoarage(
                          COMMON_CONSTANTS.ROLE,
                          userActivityResp.role.roleName
                        );
                      }
                      return this.setDataAndRedirect(responseObj);
                    }).catch((error) => {
                      this.openSnagPopup(error);
                    });
                }
              }
            }
            if (environment.ENV === "localAM") {
              const mockEui = this.httpClient.get('src/assets/tfb-acctmgmt/content-and-assets/rest-apis/eui-mock-token.json');
              // tslint:disable-next-line: max-line-length
              const mockEuiTokenData = JSON.stringify(mockEui);
              this._cacheSvc.putInSessionStoarage(
                COMMON_CONSTANTS.EUI_TOKEN_DATA,
                mockEuiTokenData
              );
              this._cacheSvc.putInSessionStoarage(
                COMMON_CONSTANTS.ROLE,
                COMMON_CONSTANTS.BO
              );
            }
          })

      }
      // }, (err) => {
      //     // console.log(err);
      // });
    });
  }

  setDataAndRedirect(responseObj) {
    const msisdn = this._cacheSvc.getFromSessionStorage(
      COMMON_CONSTANTS.MSISDN
    );
    this._cacheSvc.putInSessionStoarage(
      COMMON_CONSTANTS.ACTIVITIES_DATA,
      JSON.stringify(responseObj)
    );
    this.utilsSvc.findLighthouse_AccMngmnt_Activities(responseObj);
    this.utilsSvc.setApprovalActivities(responseObj.responseList);
    const redirecturl = this._cacheSvc.getFromSessionStorage(
      COMMON_CONSTANTS.REDIRECT_URL
    );
    if (redirecturl === "apps/tfb_acctmgmt/account-management/line-details") {
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.SELECTED_MSISDN,
        msisdn
      );
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN,
        msisdn
      );
    }
    if (
      redirecturl ===
        "apps/tfb_acctmgmt/account-management/line-details/changeservice" ||
      redirecturl === "apps/tfb_acctmgmt/account-management/lines/changeservice"
    ) {
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN,
        msisdn
      );
    }
    if(redirecturl.includes('/account-management/home')){
      return true;
    }else{
    this._router.navigate([
      redirecturl || COMMON_CONSTANTS.HOME_URL,
    ]);
   }
  }

  tokenResolvedAhubOkta(next) {
    return this._oktaAuthService.getOktaaAccessToken().then((response) => {
      sessionStorage.setItem(
        COMMON_CONSTANTS.OKTA_ACCESS_TOKEN_KEY,
        response["access_token"] || response.accessToken
      );
      sessionStorage.setItem(
        COMMON_CONSTANTS.OKTA_ID_TOKEN,
        response["id_token"] || response.idToken
      );
      if (environment.ENABLE_CW_NON_IOT) {
        if (!this.getDataFromSharedCookie()) {
          return false;
        }
      }

      sessionStorage.setItem(COMMON_CONSTANTS.ID_TOKEN, response["id_token"] || response.idToken);

      return this._oktaAuthService.getOktaUserProfile().then((userProfile) => {
        return this.addOrgAndUserDetailsInSession(next, userProfile);
      }).catch((error) => {
        this.openSnagPopup(error);
      });

    });
  }
  tokenResolvedAhubAzure(next) {
    return this._azureAuthService.getAzureAccessToken().then((response) => {
      sessionStorage.setItem(
        COMMON_CONSTANTS.AZURE_ACCESS_TOKEN_KEY,
        response["access_token"] || response.accessToken
      );
      sessionStorage.setItem(
        COMMON_CONSTANTS.AZURE_ID_TOKEN,
        response["id_token"] || response.idToken
      );
      if (environment.ENABLE_CW_NON_IOT) {
        if (!this.getDataFromSharedCookie()) {
          return false;
        }
      }

      sessionStorage.setItem(COMMON_CONSTANTS.ID_TOKEN, response["id_token"] || response.idToken);

      return this._azureAuthService.getAzureUserProfile().then((userProfile) => {
       return this.addOrgAndUserDetailsInSession(next, userProfile);
      }).catch((error) => {
        this.openSnagPopup(error);
      });

    });
  }

  addOrgAndUserDetailsInSession(next, userProfile) {
    if (environment.ENABLE_ENTITLEMENT && environment.ENABLE_RAHUB_FLOW) {
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.IS_HANDSHAKE_COMPLETE,
        COMMON_CONSTANTS.TRUE_TXT
      );
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.EUI_TOKEN_DATA,
        JSON.stringify(userProfile)
      );
      this.utilsSvc.changeActivityForLH_User$.next(true);
      // return this._apigeeSvc.getTokens().then((token) => {
      if (!this.isRedirect) {
        // tslint:disable-next-line:max-line-length
        return this.contentService
          .GetContentData(
            this._envSvc.CURR_CONTENT_URLS.CONTENT_ACCOUNT_MANAGEMENT
          )
          .then((data) => {
            this._loaderSvc.stop();
            this.authoringContentData =
              data.par.account_management_authoring;
            this._cacheSvc.putInSessionStoarage(
              COMMON_CONSTANTS.CONTENT,
              JSON.stringify(this.authoringContentData)
            );
            ContentService.SetCache(
              COMMON_CONSTANTS.CONTENT,
              this.authoringContentData
            );
            const msisdn = this._cacheSvc.getFromSessionStorage(
              COMMON_CONSTANTS.MSISDN
            );
            this._cacheSvc.putInSessionStoarage(
              MANAGE_LINE_CONST.AUTHENTICATION_INFO,
              // tslint:disable-next-line: max-line-length
              JSON.stringify({
                logonID: userProfile.logonId,
                logonEmail: userProfile.logonId,
                dealerCode: this.dealerCode,
              })
            );
            this._cacheSvc.putInSessionStoarage(
              COMMON_CONSTANTS.ORG_ID_KEY,
              this._helperUtilSvc.getOrgID()
            );

            if (
              this._cacheSvc.getFromSessionStorage("IDPType") ===
              COMMON_CONSTANTS.IAM_KEY
            ) {
              this.euiCode = _.get(next, COMMON_CONSTANTS.EUI_CODE, "");
              this.entitlementSvc
                .getIamAccessToken(this.euiCode)
                .then((tokenData) => {
                  const idTokenArr = tokenData.id_tokens;
                  let token: string = "";
                  idTokenArr.forEach((tokenObj: any) => {
                    if (
                      !_.isEmpty(tokenObj) &&
                      !_.isEmpty(tokenObj["id_token.none"])
                    ) {
                      token = tokenObj["id_token.none"];
                      sessionStorage.setItem(
                        COMMON_CONSTANTS.ID_TOKEN,
                        token
                      );
                    }
                  });
                  const iamUserProfile = tokenData.userInfo;
                  sessionStorage.setItem(
                    "IAM_USER_PROFILE",
                    JSON.stringify(iamUserProfile.iamProfile)
                  );

                  const euiData = {
                    lastName: iamUserProfile.iamProfile.lastName,
                    firstName: iamUserProfile.iamProfile.firstName,
                    orgId: iamUserProfile.iamProfile.orgId,
                    logonId: iamUserProfile.iamProfile.email,
                    autoGeneratedFlag:
                    iamUserProfile.iamProfile.autoGeneratedFlag,
                  };
                  this._cacheSvc.putInSessionStoarage(
                    COMMON_CONSTANTS.EUI_TOKEN_DATA,
                    JSON.stringify(euiData)
                  );
                  this._cacheSvc.putInSessionStoarage(
                    COMMON_CONSTANTS.IS_HANDSHAKE_COMPLETE,
                    COMMON_CONSTANTS.TRUE_TXT
                  );
                });
            }

            if (environment.ENV === "localAM") {
              const mockEui = this.httpClient.get('src/assets/tfb-acctmgmt/content-and-assets/rest-apis/eui-mock-token.json');
              // tslint:disable-next-line: max-line-length
              const mockEuiTokenData = JSON.stringify(mockEui);
              this._cacheSvc.putInSessionStoarage(
                COMMON_CONSTANTS.EUI_TOKEN_DATA,
                mockEuiTokenData
              );
              this._cacheSvc.putInSessionStoarage(
                COMMON_CONSTANTS.ROLE,
                COMMON_CONSTANTS.BO
              );
            }

            // making roles + activity call
            return this.entitlementSvc
              .entitlementFetchActivityID_ByRoles_AHUB()
              .then((activitiesData) => {
                const responseObj = activitiesData;
                this._cacheSvc.putInSessionStoarage(
                  "activitiesData",
                  JSON.stringify(responseObj)
                );
                this.utilsSvc.findLighthouse_AccMngmnt_Activities(
                  activitiesData
                );

                let redirecturl = this._cacheSvc.getFromSessionStorage(
                  "reDirectionUrl"
                );

                if(environment.ENABLE_LIGHTHOUSE_IN_AHUB && this._helperUtilSvc.isDataExistInTEA()){
                  this._cacheSvc.putInSessionStoarage(MANAGE_LINE_CONST.BAN, this._helperUtilSvc.getBanFromPnpContext());
                  this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.BAN_LIST_KEY, this._helperUtilSvc.getBanFromPnpContext());
                  this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_MANAGE_LINES], {replaceUrl: true});
                  return false;
                }
                if (
                  redirecturl ===
                  "apps/tfb_acctmgmt/account-management/line-details"
                ) {
                  this._cacheSvc.putInSessionStoarage(
                    "selectedMisdin",
                    msisdn
                  );
                  this._cacheSvc.putInSessionStoarage(
                    COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN,
                    msisdn
                  );
                }
                if (
                  redirecturl ===
                  "apps/tfb_acctmgmt/account-management/lines/changeservice"
                ) {
                  this._cacheSvc.putInSessionStoarage(
                    COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN,
                    msisdn
                  );
                }
                if(redirecturl.includes('/account-management/home')){
                  return true;
                }else{
                this._router.navigate([
                  redirecturl || COMMON_CONSTANTS.HOME_URL,
                ]);
                }

              }).catch((error) => {
                this.openSnagPopup(error);
              });
          });
      }
      // }, (err) => {
      //     // console.log(err);
      // });
    } else {
      this._router.navigate([COMMON_CONSTANTS.RESTRICT_PAGE_URL]);
      return false;
    }
  }

  getDataFromSharedCookie() {
    if (
      this.validateCookie(
        this.utilsSvc.getCookie(COMMON_CONSTANTS.ORG_USER_TYPE)
      )
    ) {
      let userTypeCookie: any = this.utilsSvc.getCookie(
        COMMON_CONSTANTS.ORG_USER_TYPE
      );
      if (!isNullOrUndefined(userTypeCookie)) {
        userTypeCookie = JSON.parse(atob(decodeURIComponent(userTypeCookie)));
        this._cacheSvc.putInSessionStoarage(
          COMMON_CONSTANTS.ORG_ID_KEY,
          userTypeCookie.orgId
        );
        this._cacheSvc.putInSessionStoarage(
          COMMON_CONSTANTS.USER_ID,
          userTypeCookie.userId || ''
        );
        if (
          userTypeCookie.productType.toString() ===
          COMMON_CONSTANTS.DIGITS.THREE.toString()
        ) {
          this._cacheSvc.putInSessionStoarage(
            COMMON_CONSTANTS.ROLE,
            COMMON_CONSTANTS.IOT
          );
        }else{
          this._cacheSvc.deleteFromSessionStoarage(COMMON_CONSTANTS.ROLE);
        }
        return true;
      } else {
        this.utilsSvc.navigateToOrgSearch();
      }
    } else {
      return false;
    }
  }
  validateCookie(cookie: any) {
    try {
      if (
        isNullOrUndefined(cookie) ||
        cookie == COMMON_CONSTANTS.STRING_SPACE ||
        cookie == COMMON_CONSTANTS.STRING_EMPTY
      ) {
        throw Error("Invalid cookie");
      }
      if (atob(decodeURIComponent(cookie)) == COMMON_CONSTANTS.STRING_EMPTY) {
        throw Error("Invalid cookie");
      }
      let decodedCookie: any = JSON.parse(atob(decodeURIComponent(cookie)));
      if (
        isNullOrUndefined(
          decodedCookie ||
            decodedCookie.orgId ||
            decodedCookie.userId ||
            decodedCookie.productType
        )
      ) {
        throw Error("Invalid cookie");
      }
      if (
        decodedCookie.orgId == COMMON_CONSTANTS.STRING_EMPTY ||
        decodedCookie.orgId == COMMON_CONSTANTS.STRING_SPACE ||
        decodedCookie.productType == COMMON_CONSTANTS.STRING_EMPTY ||
        decodedCookie.productType == COMMON_CONSTANTS.STRING_SPACE
      ) {
        throw Error("Invalid cookie");
      }
      if (
        decodedCookie.productType != COMMON_CONSTANTS.DIGITS.ONE &&
        decodedCookie.productType != COMMON_CONSTANTS.DIGITS.THREE
      ) {
        throw Error("Invalid cookie");
      }
      return true;
    } catch (error) {
      setTimeout(() => {
        this.utilsSvc.navigateToOrgSearch();
      }, 2000);
      let err: any = {};
      err.userMessage = COMMON_CONSTANTS.COOKIE_NOTAVALIABLE_MESSAGE;
      err.code = COMMON_CONSTANTS.COOKIE_NOTAVALIABLE_CODE;
      this.utilsSvc.errorHandling(err);
      return false;
    }
  }

  openSnagPopup(error: any) {
    const api_url = error.url  ? error.url : COMMON_CONSTANTS.HIT_A_SNAG;
    const errorType = COMMON_CONSTANTS.HIT_A_SNAG;
    const req =  {url: api_url};
    const errorMsg = error.stack  ? error.stack : error;
    this.splunkSvc.logInSplunk( req, errorMsg, errorType);
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    this.snagPopupRef = this.modalService.open(AlertConfirmPopupComponent, ngbModalOptions);
    this.snagPopupRef.componentInstance.doneClicked.subscribe((data)=>{
      if (data) {
        this.utilsSvc.navigateToDashboard();
      }
    })
    this.snagPopupRef.componentInstance.isSnagPopup = true;
    this.snagPopupRef.componentInstance.title = this.authoringContentData?.resolverContent?.snagHeader;
    this.snagPopupRef.componentInstance.message = this.authoringContentData?.resolverContent?.snagMessage;
    this.snagPopupRef.componentInstance.btnOkText = this.authoringContentData?.resolverContent?.doneText;
  }
}
